import { createSingleEntityStore } from '@core/ngrx-legacy';
import type { StatsSidebar } from '@core/stats-types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<StatsSidebar>()('DashboardStatsSidebar');

export {
  actions as DashboardStatsSidebarActions,
  selectors as DashboardStatsSidebarSelectors,
  reducer as DashboardStatsSidebarReducer,
  namespace as DashboardStatsSidebarNamespace,
};
